import React from "react";
import { Link } from "react-router-dom";
import Navigation from "./Navigation";
import * as S from "./styles";

class Header extends React.Component {
  state = {
    isOpen: false,
    topOffset: 0,
    maxOffset: 0,
  };

  componentDidMount() {
    document.addEventListener("click", this.onDocumentClick);
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);
    this.onScroll();
    this.onResize();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onDocumentClick);
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }

  onDocumentClick = (e) => {
    if (
      // !this._works.contains(e.target) &&
      !this._worksToggle.contains(e.target)
    ) {
      this.setState({
        isOpen: false,
      });
    }
  };

  onScroll = () => {
    const topOffset = Math.max(
      0,
      Math.min(window.pageYOffset, this.state.maxOffset)
    );
    if (topOffset !== this.state.topOffset) {
      this.setState({
        topOffset: topOffset,
      });
    }
  };

  onResize = () => {
    const containerRect = this._container.getBoundingClientRect();
    const innerRect = this._inner.getBoundingClientRect();
    const maxOffset = innerRect.top - containerRect.top;
    const topOffset = Math.min(this.state.topOffset, maxOffset);
    this.setState({
      maxOffset,
      topOffset,
    });
  };

  onWorksToggleClick = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    let { pages, works } = this.props;
    const style = {
      transform: `translateY(${-1 * this.state.topOffset}px)`,
    };
    return (
      <>
        <S.Container
          style={style}
          ref={(c) => {
            this._container = c;
          }}
        >
          <S.Inner
            ref={(c) => {
              this._inner = c;
            }}
          >
            <S.SiteTitle>
              <Link to="/">James Welling</Link>
            </S.SiteTitle>
            <div>
              <S.WorksToggle
                selected={this.state.isOpen}
                onClick={this.onWorksToggleClick}
                // onMouseEnter={this.onWorksToggleClick}
                ref={(c) => {
                  this._worksToggle = c;
                }}
              >
                Works
              </S.WorksToggle>
            </div>
          </S.Inner>
          <S.Works
            ref={(c) => {
              this._works = c;
            }}
            open={this.state.isOpen}
          >
            <ul>
              {works.map((o, i) => {
                let title = o.title;
                if (o.years) {
                  title = [o.title, o.years].join(", ");
                }
                return (
                  <li key={i}>
                    <Link to={`/${o.uri}`}>{title}</Link>
                  </li>
                );
              })}
            </ul>
          </S.Works>
        </S.Container>
        <Navigation pages={pages} />
      </>
    );
  }
}

export default Header;
